"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from "react";
import { composeDataMethods } from "@lululemon/mwa-utils";
var HeaderFlagContext = /*#__PURE__*/ createContext(null);
export var useHeaderFlags = function() {
    var context = useContext(HeaderFlagContext);
    if (!context) {
        throw new Error("This component must be wrapped in WithHeaderFlags.");
    }
    return context;
};
export var withHeaderFlags = function(featureHeaders) {
    return function(Component) {
        var WithHeaderFlag = function(_param) {
            var headerFlags = _param.headerFlags, props = _object_without_properties_loose(_param, [
                "headerFlags"
            ]);
            var contextProps = useMemo(function() {
                return headerFlags;
            }, [
                headerFlags
            ]);
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(HeaderFlagContext.Provider, {
                    value: contextProps,
                    children: /*#__PURE__*/ _jsx(Component, _extends({}, props))
                })
            });
        };
        composeDataMethods(Component, {
            getInitialProps: /*#__PURE__*/ _async_to_generator(function(appContext) {
                var headerFlags, ctx, key, _ctx_req_headers, _ctx_req, header, headerValue;
                return _ts_generator(this, function(_state) {
                    headerFlags = {};
                    if (!featureHeaders || Object.keys(featureHeaders).length === 0) {
                        throw new Error("Header Flags: have you added header flag object correctly");
                    }
                    ctx = appContext.ctx || appContext;
                    for(var key in featureHeaders){
                        if (featureHeaders.hasOwnProperty(key)) {
                            ;
                            header = featureHeaders[key];
                            headerValue = evaluateFlag((_ctx_req = ctx.req) == null ? void 0 : (_ctx_req_headers = _ctx_req.headers) == null ? void 0 : _ctx_req_headers[header], key);
                            headerFlags[key] = !!headerValue;
                            ctx[key] = !!headerValue;
                        }
                    }
                    return [
                        2,
                        {
                            headerFlags: headerFlags
                        }
                    ];
                });
            })
        })(WithHeaderFlag);
        return WithHeaderFlag;
    };
};
var evaluateFlag = function(header, key) {
    if (Array.isArray(header)) {
        console.error("Header Flags: Feature header is an array, this is not supported, render will continue with feature flag disabled");
        return false;
    }
    if (header) {
        try {
            return JSON.parse(header);
        } catch (e) {
            console.error("Header Flags: Feature header value must be a string of 'true' or 'false', render will continue with feature flag disabled.");
            return false;
        }
    }
    // Client-side
    if (typeof window !== "undefined") {
        var _window___NEXT_DATA___props_layoutProps_headerFlags, _window___NEXT_DATA___props_layoutProps, _window___NEXT_DATA___props, _window___NEXT_DATA__;
        return (_window___NEXT_DATA__ = window.__NEXT_DATA__) == null ? void 0 : (_window___NEXT_DATA___props = _window___NEXT_DATA__.props) == null ? void 0 : (_window___NEXT_DATA___props_layoutProps = _window___NEXT_DATA___props.layoutProps) == null ? void 0 : (_window___NEXT_DATA___props_layoutProps_headerFlags = _window___NEXT_DATA___props_layoutProps.headerFlags) == null ? void 0 : _window___NEXT_DATA___props_layoutProps_headerFlags[key];
    }
    return false;
};
